import {IFriendlyQuery} from "../../list/types/friendly_query";
import {buildOfferListUrl} from "../offer_list_url/build_offer_list_url";

export const buildFriendlyOfferListLink = (query: Partial<IFriendlyQuery>): string => buildOfferListUrl(query);
import {IFriendlyQuery} from "../../list/types/friendly_query";
import {buildOfferListUrl} from "../offer_list_url/build_offer_list_url";

export const buildFriendlyOfferListLink = (query: Partial<IFriendlyQuery>): string => buildOfferListUrl(query);
